import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccordionService {
  private readonly activeAccordionId: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  constructor() {}

  get activeAccordionId$(): Observable<string | null> {
    return this.activeAccordionId.asObservable();
  }

  public setActiveAccordionId(id: string | null): void {
    this.activeAccordionId.next(id);
  }
}
